<template>
  <section class="Introduction__method">
    <div class="inner">
      <h2 class="Head__frame Head__frame_blue">
        <span class="Head__frame_blue_inner">ご紹介方法</span>
      </h2>
      <div class="Introduction__method_area">
        <div class="Introduction__method_box Introduction__method_box--al_top">
          <div class="Introduction__method_box_l">
            <div class="Introduction__head_chara Introduction__head_chara--column Introduction__head_chara--green">
              紹介する人
            </div>
          </div>
          <div :class="`Introduction__method_box_r ${classForPC}`">
            <h4 class="Introduction__method_box_head">
              <span class="Introduction__method_box_head_num">1</span>紹介メッセージを送信
            </h4>
            <div class="Introduction__method_box_r_sns_area Introduction__sns_area">
              <div v-show="!isPC" class="Introduction__sns_box">
                <ShareNetwork
                  class="Introduction__sns_box_btn Introduction__sns_box_btn--cl01"
                  network="line"
                  :popup="{width: 800, height: 800}"
                  :url="linkIntroduce"
                  :title="lineMessage"
                >
                  LINEで送る
                </ShareNetwork>
              </div>
              <div class="Introduction__sns_box">
                <ShareNetwork
                  class="Introduction__sns_box_btn Introduction__sns_box_btn--cl02"
                  network="email"
                  url=""
                  :title="emailSubject"
                  :description="`${emailBody}${linkIntroduce}`"
                >
                  メールで送る
                </ShareNetwork>
              </div>
              <div class="Introduction__sns_box">
                <button class="Introduction__sns_box_btn Introduction__sns_box_btn--cl03" @click.stop.prevent="copysharingCode">
                  紹介用URLをコピー
                  <input id="testing-code" type="hidden" :value="linkIntroduce">
                </button>
              </div>
              <div v-show="!isPC" class="Introduction__sns_box Introduction__sns_box_link_area">
                <a class="Introduction__sns_box_link Introduction__sns_box_link--insta" @click.stop.prevent="shareInstagram" />
                <ShareNetwork
                  class="Introduction__sns_box_link Introduction__sns_box_link--twitter"
                  network="twitter"
                  :url="linkIntroduce"
                  :popup="{width: 800, height: 800}"
                  title="Register MelonTV"
                />
                <ShareNetwork
                  class="Introduction__sns_box_link Introduction__sns_box_link--fb"
                  network="facebook"
                  :url="linkIntroduce"
                  :popup="{width: 800, height: 800}"
                  title="Register MelonTV"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="Introduction__method_box Introduction__method_box--sp_center">
          <div class="Introduction__method_box_l">
            <div class="Introduction__head_chara Introduction__head_chara--column Introduction__head_chara--pink">
              紹介された人
            </div>
          </div>
          <div class="Introduction__method_box_r">
            <h4 class="Introduction__method_box_head">
              <span class="Introduction__method_box_head_num">2</span>紹介メッセージのURLからご登録
            </h4>
          </div>
        </div>
        <div class="Introduction__method_box Introduction__method_box--sp_center">
          <div class="Introduction__method_box_l">
            <div class="Introduction__head_chara Introduction__head_chara--column Introduction__head_chara--pink">
              紹介された人
            </div>
          </div>
          <div class="Introduction__method_box_r">
            <h4 class="Introduction__method_box_head">
              <span class="Introduction__method_box_head_num">3</span>トライアルが終了し、有料会員へ
            </h4>
          </div>
        </div>
        <div class="Introduction__method_box Introduction__method_box--sp_center">
          <div class="Introduction__method_box_l">
            <div class="Introduction__head_chara Introduction__head_chara--column Introduction__head_chara--green">
              紹介する人
            </div>
          </div>
          <div class="Introduction__method_box_r">
            <h4 class="Introduction__method_box_head">
              <span class="Introduction__method_box_head_num">4</span>利用料が1ヶ月無料
            </h4>
          </div>
        </div>
        <div class="Introduction__method_box Introduction__method_box--sp_center">
          <div class="Introduction__method_box_l">
            <div class="Introduction__head_chara Introduction__head_chara--column Introduction__head_chara--pink">
              紹介された人
            </div>
          </div>
          <div class="Introduction__method_box_r">
            <h4 class="Introduction__method_box_head">
              <span class="Introduction__method_box_head_num">5</span>MELONの利用2ヶ月目が無料
            </h4>
            <p class="Introduction__method_box_r_notes">
              ※トライアル終了から1ヵ月間はサービス利用料が発生します
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { ShareNetwork } from 'vue-social-sharing'
import authService from '@/services/authService'
import platform from 'platform-detect'

export default {
  name: 'IntroductionMethod',
  components: { ShareNetwork },
  data: function() {
    return {
      linkIntroduce: '',
      isPC: false,
      classForPC: '',
      emailBody: 'マインドフルネスサロン「MELONオンライン」から招待が届きました。\nストレスの多い日々。サロンのみんなと一緒に日常をマインドフルに塗り替えよう！\n\n====\n1ヶ月（4950円）が無料になるお得な特典付き！\n\n※ 登録2ヶ月目の利用料が無料となります。\n====\n\n<登録URL>\n',
      emailSubject: '最高のすっきりに出会おう。',
      lineMessage: 'マインドフルネスサロン「MELONオンライン」から招待が届きました。\nストレスの多い日々。サロンのみんなと一緒に日常をマインドフルに塗り替えよう！\n\n====\n1ヶ月（4950円）が無料になるお得な特典付き！\n\n※ 登録2ヶ月目の利用料が無料となります。\n====\n\n<登録URL>\n'
    }
  },
  mounted() {
    this.getUserInfo()
    this.handleResize()
  },
  methods: {
    async getUserInfo() {
      const response = await authService.getUserInfo()
      const user_id = response.user.user.id
      this.linkIntroduce = `${window.location.origin}/member-register?user_introduce=${user_id}`
    },
    copysharingCode() {
      navigator.clipboard.writeText(this.linkIntroduce).then(() => {
        alert('コピーが完了しました。')
      }, () => {
        alert('Oops, unable to copy')
      })
    },
    async shareInstagram() {
      await navigator.clipboard.writeText(this.linkIntroduce)
      window.open('https://instagram.com', '_blank')
    },
    handleResize() {
      if (platform.ios || platform.android) {
        this.isPC = false
        this.classForPC = ''
      } else {
        this.isPC = true
        this.classForPC = 'class-hide-SNS-PC'
      }
    }
  }
}
</script>
